import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { FincenMatchesTable } from '../../../../../../../../../../features/watchlist/fincen/match/fincen-match-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceFincen,
      label: 'Matches',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceFincen>,
  head: () => getPageHead('FinCEN Matches'),
  component: FincenMatchList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return <PageTabRail actions={filter} group={TabbedNavigationGroup.ClearingComplianceFincen} />;
}

function FincenMatchList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FincenMatchesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
